<div
  class="text-break"
  *ngIf="componentData.data$ | async as data"
  [ngClass]="hasClass(data.styleClasses, fullWidthFooterClass) ? 'container-fluid pt-11 pb-4 mx-0 mx-md-10' : 'container py-8'"
>
  <div class="row">
    <div *ngIf="data.column0Banner" class="col-12 col-xl-3 footer-banner">
      <ng-container
        [styleClassesOverride]="'banner-collection-blocks footer-promise-banner'"
        [cxComponentWrapper]="{ uid: data.column0Banner.uid, flexType: 'BannerComponent', typeCode: 'BannerComponent' }"
      ></ng-container>
    </div>
    <div class="row p-0 m-0" [ngClass]="data.column0Banner ? 'col-12 col-xl-9 mt-12 mt-md-11 mt-xl-0' : 'col-12'">
      <div class="col-12 col-md-3 left-col">
        <ng-container [cxComponentWrapper]="{ uid: data.column1Navigation.uid, flexType: 'NavigationComponent' }"></ng-container>
      </div>
      <div class="col-12 col-md-3 mt-8 mt-md-0 middle-left-col">
        <ng-container [cxComponentWrapper]="{ uid: data.column2Navigation.uid, flexType: 'NavigationComponent' }"></ng-container>
      </div>
      <div class="col-12 col-md-3 mt-8 mt-md-0 middle-right-col">
        <ng-container [cxComponentWrapper]="{ uid: data.column3Navigation.uid, flexType: 'NavigationComponent' }"></ng-container>
      </div>
      <div class="col-12 col-md-3 mt-8 mt-md-0 right-col">
        <ng-container [cxComponentWrapper]="{ uid: data.column4Navigation.uid, flexType: 'NavigationComponent' }"></ng-container>
      </div>
    </div>
  </div>
  <div
    *ngIf="data.row2Navigation || data.flexNavigation || data.socialNavigation"
    class="row d-flex flex-column flex-xl-row mx-0 mt-10 mt-md-8 extended-footer-wrapper"
  >
    <div
      class="col-12 col-xl-2 d-flex align-items-center justify-content-start justify-content-md-center justify-content-xl-start px-0 pt-7 pt-xl-0 social-links-wrapper"
    >
      <ng-container
        *ngIf="data.socialNavigation"
        [cxComponentWrapper]="{ uid: data.socialNavigation?.uid, flexType: 'CMSLinkCollectionComponent' }"
        [styleClassesOverride]="'secondary-social-links'"
      ></ng-container>
    </div>
    <div class="col-12 col-xl-8 px-0 right-col">
      <ng-container
        *ngIf="data.row2Navigation"
        [cxComponentWrapper]="{ uid: data.row2Navigation?.uid, flexType: 'NavigationComponent' }"
        [styleClassesOverride]="'navigation-horizontal py-7'"
      ></ng-container>
    </div>
    <div
      class="col-12 col-xl-2 d-flex align-items-center justify-content-start justify-content-md-center justify-content-xl-end pb-7 pb-xl-0 px-0"
    >
      <ng-container
        [cxComponentWrapper]="{
          uid: data.flexNavigation?.uid,
          flexType: 'CmsFooterCountrySelectorComponent'
        }"
      ></ng-container>
    </div>
  </div>
</div>
